import { useRef, useState } from "react";
import { REJECT_CATEGORIES } from "../api/types";

interface RejectModalProps {
  onConfirm: (categories: string[], note: string) => void;
  onCancel: () => void;
  loading?: boolean;
}

export function RejectModal({ onConfirm, onCancel, loading }: RejectModalProps) {
  const [categories, setCategories] = useState<string[]>([]);
  const [note, setNote] = useState("");
  const backdropMouseDown = useRef(false);

  const isValid = categories.length > 0 && note.trim().length >= 3;

  function toggleCategory(value: string) {
    setCategories((prev) =>
      prev.includes(value) ? prev.filter((c) => c !== value) : [...prev, value],
    );
  }

  return (
    <div className="dialog-overlay"
      onMouseDown={(e) => { backdropMouseDown.current = e.target === e.currentTarget; }}
      onClick={(e) => { if (e.target === e.currentTarget && backdropMouseDown.current) onCancel(); }}>
      <div className="dialog-card"
        onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h2 style={{ display: "flex", alignItems: "center", gap: "var(--space-2)" }}>
            <span className="material-symbols-outlined" style={{ color: "var(--indaco-danger)" }}>cancel</span>
            Scarta richiesta
          </h2>
        </div>

        <div style={{ marginBottom: "var(--space-3)" }}>
          <label className="form-label">Motivazione (seleziona una o più)</label>
          <div style={{ display: "flex", flexDirection: "column", gap: "var(--space-1)" }}>
            {REJECT_CATEGORIES.map((cat) => (
              <label key={cat.value} style={{
                display: "flex", alignItems: "center", gap: "var(--space-2)",
                padding: "var(--space-2)", borderRadius: "var(--border-radius-sm)",
                background: categories.includes(cat.value) ? "var(--indaco-danger-light)" : "var(--indaco-gray-50)",
                cursor: "pointer", fontSize: "var(--font-size-sm)",
              }}>
                <input type="checkbox" checked={categories.includes(cat.value)}
                  onChange={() => toggleCategory(cat.value)} />
                {cat.label}
              </label>
            ))}
          </div>
        </div>

        <div style={{ marginBottom: "var(--space-4)" }}>
          <label className="form-label">Note (obbligatorio, min. 3 caratteri)</label>
          <textarea className="form-textarea" rows={3} value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Descrivi perché la richiesta viene scartata..." />
        </div>

        <div className="dialog-footer">
          <button className="btn btn-outline" onClick={onCancel} disabled={loading}>Annulla</button>
          <button className="btn btn-danger" disabled={!isValid || loading}
            onClick={() => onConfirm(categories, note.trim())}>
            {loading && <span className="spinner" style={{ width: 14, height: 14, marginRight: 4 }} />}
            Conferma scarto
          </button>
        </div>
      </div>
    </div>
  );
}
